import React from 'react';

export default function PackagesGeneral() {
	return <div></div>;
}
